/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IYfgFooterViewProps, SocialNetwork } from './yfg-footer';
// import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
// import { TextValueTranslation } from '@msdyn365-commerce/retail-proxy';
import { IMenuItemData } from './yfg-footer.data';

export default (props: IYfgFooterViewProps) => {
    // TODO: -> Filtres forbidden + ordenar categories i subcategories
    const {
        subscribe,
        iframe,
        config: { socialArray, title },
        navigationItems
    } = props;

    const titleFontStyle: React.CSSProperties = {
        fontSize: (title?.fontSize as number) ?? 60,
        lineHeight: `${(title?.fontSize as number) ?? 60}px`
    };

    return (
        <div className='yfg-footer row py-40'>
            <div
                className='col-12 col-md-9 text-white text-title px-20 px-40-md mb-40-md mb-20'
                style={title?.fontSize ? titleFontStyle : undefined}
            >
                {title?.text ?? 'Pimkie trends'}
            </div>
            <div className='col-12 col-md-3 text-white subscribe-container px-20 pr-40-md'>
                {/* <div className='subscribe-label mb-24'>
                    Suscríbete a nuestra Newsletter y te enviaremos información sobre novedades y tendencias
                </div>
                <div className=''>
                    <a className='subscribe-btn text-white py-16 px-30' href='www.wekode.es'>
                        Suscríbete
                    </a>
                </div> */}
                {subscribe}
                {iframe}
            </div>
            <div className='col-12 d-flex my-40 px-20 px-40-md'>
                <div className='yfg-footer-label d-flex text-white mr-32'>Go to:</div>
                {_renderSubcategories(props.subCategoriesItemList)}
            </div>
            <div className='col-12 px-40-md'>
                <div className='border-tp-white-1px d-flex gap-32px py-12 mb-40 overflow-x-auto overflow-hidden'>{navigationItems}</div>
            </div>
            <div className='col-12 px-20 px-40-md'>
                <div className='col-8 social-networks-container d-flex gap-32px'>{_renderSocialNetworks(socialArray ?? [])}</div>
            </div>
        </div>
    );
};

const _renderSubcategories = (subcategories: IMenuItemData[]): JSX.Element => {
    return (
        <div className='overflow-x-auto d-flex gap-32px'>
            <React.Fragment>{subcategories.map(sc => _renderSubcategory(sc))}</React.Fragment>
        </div>
    );
};

const _renderSubcategory = (subcategory: IMenuItemData): JSX.Element => {
    return (
        <a key={subcategory.id} className='yfg-link text-underline text-white white-space-no-wrap' href={subcategory.linkURL}>
            {subcategory.linkText}
        </a>
    );
};

const _renderSocialNetworks = (socialNetworks: SocialNetwork[]): JSX.Element => {
    return <React.Fragment>{socialNetworks.map(sn => _renderSocialNetwork(sn))}</React.Fragment>;
};

const _renderSocialNetwork = (socialNetwork: SocialNetwork): JSX.Element => {
    return (
        <a href={socialNetwork.url}>
            <img className='img-social-network' src={socialNetwork.icon.src} />
        </a>
    );
};
